export default __webpack_public_path__ + "media/images/manual/joanr/12-9e47361173d81b25d107aca985b6a3cd.png";